export default __webpack_public_path__ + "static/Tip-9-Eat-less-plane-food-da5e218e0574a0693f16fdfbf9e41188.jpg";